import { Box, Stack, Typography } from "@mui/material";
import { IsMdScreen } from "helpers/hooks";
import { ResourceTypography } from "Modules/Marketing/Resources/Resources.styled";
import { Link as RouterLink } from "react-router-dom";
import { ShButton } from "shared/SharedStyles/ShInputs";
import { ShContainer } from "shared/SharedStyles/ShLayouts";
import CommonQuestionSidebar from "../CommonQuestionSidebar";

export const OnboardingHelp = () => {
  const isMdScreen = IsMdScreen();

  return (
    <Stack direction="row" spacing={2}>
      <ShContainer maxWidth='xl' sx={{ flex: 1 }}>
        <ResourceTypography variant="h5" fontWeight={"bold"} gutterBottom>
          Onboarding
        </ResourceTypography>
        <ResourceTypography variant="body1" paragraph>
          Create a seamless onboarding experience for new hires with automated workflows,
          document collection, and task management. Ensure a smooth transition from candidate to employee.
        </ResourceTypography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Onboarding Workflows
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Design custom onboarding workflows for different roles and departments.
          Automate task assignments, document collection, and training schedules.
        </Typography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Document Management
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Collect and manage new hire documents securely. Create digital forms for
          tax documents, benefits enrollment, and other required paperwork.
        </Typography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Task Automation
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Automate onboarding tasks such as equipment requests, system access setup,
          and training schedule creation. Track completion and follow up automatically.
        </Typography>

        <ResourceTypography variant="h6" fontWeight={"bold"} gutterBottom>
          Welcome Materials
        </ResourceTypography>
        <Typography variant="body1" paragraph>
          Create and distribute welcome materials, including company policies,
          benefits information, and first-day instructions. Personalize content for each new hire.
        </Typography>

        <Box paddingTop={2} paddingBottom={3}>
          <ShButton
            component={RouterLink}
            to="/employer/settings/tools/onboarding"
            color="primary"
            variant="contained"
          >
            Configure Onboarding
          </ShButton>
        </Box>
      </ShContainer>
      {!isMdScreen && <CommonQuestionSidebar />}
    </Stack>
  );
};

export default OnboardingHelp; 